import { useState, useEffect } from 'react'
import { isPurMode } from '@/utils/app/paid'

export function useIsPurMode() {
  const [purMode, setPurMode] = useState(false)
  useEffect(() => {
    if (isPurMode()) setPurMode(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return purMode
}
